import { render } from "./SlideTextImage.vue?vue&type=template&id=5d405268&ts=true"
import script from "./SlideTextImage.vue?vue&type=script&lang=ts"
export * from "./SlideTextImage.vue?vue&type=script&lang=ts"

import "./SlideTextImage.vue?vue&type=style&index=0&id=5d405268&lang=stylus"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__